<template>
    <el-dialog :title="$t('right_groups.dialog_title')" :visible.sync="showPopup" append-to-body  class="my-dialog-class">
        
        <el-form :label-position="'top'" :inline="false" :rules="rules" label-width="100%"  :model='selectedObject'  ref='my-form' @submit.prevent="save" v-loading="loading">
             <el-row :gutter="12">    
                 <el-col :span="24">
                    <el-form-item :label="$t('right_groups.name')" prop="Name" :required="true">
                        <el-input  v-model="selectedObject.Name" placeholder="Name" autofocus></el-input>
                    </el-form-item>
                 </el-col>
             </el-row>
             
             <el-row  :gutter="12">
                 <el-col :span="24">
                     <el-form-item :label="$t('right_groups.group_rights')" class="full-width">
                        <el-transfer 
                        :titles="[ $t('right_groups.all_rights'), $t('right_groups.selected_rights') ]"
                        class="my-transfer" v-model="selectedObject.Rights" :data="all_rights"> </el-transfer>
                     </el-form-item>
                 </el-col>
             </el-row>

        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showPopup=false">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="save">{{ $t("confirm") }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import settings from "./../../backend/LocalSettings";

export default {
  name: "right-groups-dialog",
  data () {
    return { 
      loading: false,
      showPopup: false,
      mode: 'add',
      selectedObject: {},
      all_rights: [],
      rules: {
          Name: [ { required: true, message: this.$t('right_groups.name_rquired') } ]
      }
    }
  },
  methods: {
    show_me: function( selectedObject ) {
        this.loading = true;
        var me = this
        this.$http
          .post('right_groups/get_dialog_info',  {} )
          .then(function (response) {
            this.loading = false;
            if( settings.verify_response(response, this.$rights)) {
              this.all_rights = response.body.AllRights;

              this.mode = "edit";
              if( selectedObject == null ) {
                  selectedObject = { Rights: [] };
                  this.mode = "add";
              }
              this.showPopup       = true;
              this.selectedObject  = JSON.parse( JSON.stringify( selectedObject ) );
              
              for (var i = 0; i < this.all_rights.length; i++) {
               if (this.all_rights[i].label === 'Manage right groups') { this.all_rights[i].label = this.$t('rights.manage_right_groups')}
               if (this.all_rights[i].label === 'Manage users') { this.all_rights[i].label = this.$t('rights.manage_users')}
               if (this.all_rights[i].label === 'Manage factories') { this.all_rights[i].label = this.$t('rights.manage_factories')}
               if (this.all_rights[i].label === 'Manage Categories') { this.all_rights[i].label = this.$t('rights.manage_categories')}
               if (this.all_rights[i].label === 'Manage Products') { this.all_rights[i].label = this.$t('rights.manage_products')}
               if (this.all_rights[i].label === 'Global Settings') { this.all_rights[i].label = this.$t('rights.global_settings')}
               if (this.all_rights[i].label === 'Access Reports') { this.all_rights[i].label = this.$t('rights.access_reports')}
               if (this.all_rights[i].label === 'Admin Menu Visible') { this.all_rights[i].label = this.$t('rights.admin_menu_visible')}
               if (this.all_rights[i].label === 'Reports Menu Visible') { this.all_rights[i].label = this.$t('rights.admin_menu_visible')}
              }
            } else {
              this.$router.push("/");
            }
          });
    },
    save: function() {
        this.$refs['my-form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$http
            .post('right_groups/save',  { mode: this.mode, object: this.selectedObject } )
            .then(function (response) {
                this.loading = false;
                if( settings.verify_response(response, this.$rights)) {
                this.showPopup = false;
                this.$emit("save");
                } else {
                this.$router.push("/");
                }
            });
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }
    .my-transfer{
        width: 600px;
        margin: 0 auto;
    }
    .el-transfer-panel {
      width: 250px;
    }
    
</style>